// NPM Imports
import React, { useContext } from 'react'
// Quote Context
import { useQuoteContext } from '../../hooks/useQuoteContext'
// Component Imports
import OneTimeDiscountsHeaderRow from '../rows/onetime-discounts/OneTimeDiscountsHeaderRow'
import QuickStartTrainingDiscountRow from '../rows/onetime-discounts/QuickStartTrainingDiscountRow'
import ImpPromotionDiscountRow from '../rows/onetime-discounts/ImpPromotionDiscountRow'
import HRImpDealDeskDiscountRow from '../rows/onetime-discounts/HRImpDealDeskDiscountRow'
import PayrollImpDealDeskDiscountRow from '../rows/onetime-discounts/PayrollImpDealDeskDiscountRow'
import SecondEINImpDiscountRow from '../rows/onetime-discounts/SecondEINImpDiscountRow'
import GroupImpDiscountRow from '../rows/onetime-discounts/GroupImpDiscountRow'
import SpacerThick from '../ui-helper-elements/SpacerThick'
import BooleanDiscount from '../ui-helper-elements/BooleanDiscount'
import NumberDiscount from '../ui-helper-elements/NumberDiscount'
import { DiscountFamilyDropdown } from '../ui-helper-elements/DiscountFamilyDropdown'
import DealDeskActive from '../ui-helper-elements/DealDeskActive'
// JS Imports
// Asset Imports

export default function OneTimeDiscountsSection() {
   const state = useQuoteContext()

   // Collect discount families and individual discounts
   let discount_families = new Set()
   let individual_discount_keys = []

   for (let discount in state.discount_list) {
      if (
         state.discount_list[discount]['Promotional'] &&
         state.discount_list[discount]['BillingFreq'] == 'once'
      ) {
         // If discount has a DiscountFamily, add to families set
         if (state.discount_list[discount]['DiscountFamily']) {
            discount_families.add(
               state.discount_list[discount]['DiscountFamily'],
            )
         } else {
            // If no DiscountFamily, add to individual discounts
            individual_discount_keys.push(
               state.discount_list[discount]['DiscountCode'],
            )
         }
      }
   }

   // Create DiscountFamilyDropdown components for each family
   let family_dropdowns = Array.from(discount_families).map((family, key) => {
      // Find the lowest DisplayOrder among discounts in this family for ordering
      let familyOrder = 999
      for (let discount in state.discount_list) {
         if (state.discount_list[discount]['DiscountFamily'] === family) {
            familyOrder = Math.min(
               familyOrder,
               state.discount_list[discount]['DisplayOrder'] || 999,
            )
         }
      }

      return (
         <DiscountFamilyDropdown
            key={`family-${key}`}
            discountFamily={family}
            order={familyOrder}
         />
      )
   })

   // Create individual discount components (excluding those with DiscountFamily)
   let onetime_discounts = individual_discount_keys.map((discountCode, key) => {
      if (state.discount_list[discountCode]['InputType'] == 'Number')
         return (
            <NumberDiscount
               key={key}
               discount_key={discountCode}
               order={state.discount_list[discountCode]['DisplayOrder']}
            />
         )
      else
         return (
            <BooleanDiscount
               key={key}
               discount_key={discountCode}
               order={state.discount_list[discountCode]['DisplayOrder']}
            />
         )
   })

   if (
      (state.user_view == 'Internal' || state.oneTimeTotal.totalDiscount > 0) &&
      state.user_role != 'Partner' &&
      state.user_role != 'Reseller'
   )
      return (
         <div className='onetimeDiscounts'>
            <SpacerThick />
            <OneTimeDiscountsHeaderRow />
            <DealDeskActive order={-50} billingFreq='once' />
            <QuickStartTrainingDiscountRow
               order={state.discount_list['quickstartDiscount']['DisplayOrder']}
            />
            <ImpPromotionDiscountRow
               order={state.discount_list['impPromotion']['DisplayOrder']}
            />
            <HRImpDealDeskDiscountRow
               order={state.discount_list['hrDealdesk']['DisplayOrder']}
            />
            <PayrollImpDealDeskDiscountRow
               order={state.discount_list['payDealdesk']['DisplayOrder']}
            />
            <SecondEINImpDiscountRow
               order={state.discount_list['secondEINDiscount']['DisplayOrder']}
            />
            <GroupImpDiscountRow
               order={state.discount_list['groupChildDiscount']['DisplayOrder']}
            />
            {onetime_discounts}
            {family_dropdowns}
         </div>
      )
}
